<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="comp-ly-avatar">
    <div class="over-list-container" v-if="user?.length > 1">
      <!-- 列表 -->
      <template v-if="sourceType == 1">
        <jw-overflow-list :min="1" :margin="nodeOnwer ? 10 : 0" :class="[nodeOnwer ? 'isNodeOwner' : '', 'over-list-wrap']">
          <div v-for="(item, index) of user" :key="index">
            <xl-avatar :avatar="{ name: item?.userName || item?.name || '', url: item?.avatar || item?.avatarOrigin, id: item?.userId || item?.id }" :size="imgSize" />
          </div>
          <template #overflow="{ number }">
            <jw-tooltip :content-style="{ maxWidth: '300px', padding: '8px 6px 0 12px' }">
              <template #content>
                <jw-space wrap align="center">
                  <template v-for="(item, index) in user.slice(-number)" :key="index">
                    <xl-avatar :avatar="{ name: item?.userName || item?.name || '', url: item?.avatar || item?.avatarOrigin, id: item?.userId || item?.id }" :size="imgSize" />
                  </template>
                </jw-space>
              </template>
              <jw-tag size="small">+{{ number }}</jw-tag>
            </jw-tooltip>
          </template>
        </jw-overflow-list>
      </template>
      <!-- 详情 -->
      <template v-if="sourceType == 2">
        <div class="avatar-list">
          <div v-for="(item, index) of user" :key="index" class="avatar-item">
            <xl-avatar :avatar="{ name: item?.userName || item?.name || '', url: item?.avatar || item?.avatarOrigin, id: item?.userId || item?.id }" :size="imgSize" />
          </div>
        </div>
      </template>
    </div>
    <template v-else-if="user?.length == 1">
      <xl-avatar v-if="user[0] && (user[0]?.userId || user[0]?.id) && (user[0].userName || user[0].name)" :avatar="{ name: user[0]?.userName || user[0]?.name || '', url: user[0]?.avatar || user[0]?.avatarOrigin, id: user[0]?.userId || user[0]?.id }" :size="imgSize" />
      <template v-else> <span class="empty-text">-</span> </template>
    </template>
    <template v-else><span class="empty-text">-</span> </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({
  record: {
    type: Object,
    default: () => {}
  },
  size: {
    type: Number || String,
    default: 22
  },
  isNodeOwner: {
    type: Boolean,
    default: false
  },
  sourceType: {
    type: Number || String,
    default: 1
  }
});
const user = computed(() => props.record);
const nodeOnwer = computed(() => props.isNodeOwner);

const imgSize = computed(() => props.size);
</script>
<style scoped lang="less">
@import './ly-avatar.less';
</style>
